import {
  BaseInputProps, CheckboxInput,
  IfFormData, ifReactNative,
  RelativeRow,
  useFormContext,
  useInputHelper
} from 'ui-builder';
import { Person, TeamRole } from 'nekst-api';
import React, { useEffect, useState } from 'react';
import { ServiceProvidersMultiDropdown } from '../../ServiceProviders';
import { ClientAppToggleWrapper } from 'feature-toggle';

export interface ServiceProvidersInputProps extends BaseInputProps<number[]> {

}

export function ServiceProvidersInput(
  props: ServiceProvidersInputProps,
) {
  const inputHelper = useInputHelper<number[]>(props);

  const formContext = useFormContext<Person>();

  const value = inputHelper.getValue();

  const [isEnabled, setIsEnabled] = useState(
    value && value.length > 0,
  );

  const clearValue = () => {
    formContext.onChangeCallback!({
      [props.source]: [],
      isSharedInClientApp: undefined,
    });
  };

  useEffect(() => {
    if (!isEnabled && value) {
      clearValue();
    }
  }, [isEnabled]);

  return (
    <IfFormData conditionFunc={(data) => data.teamRole === TeamRole.CONTACT}>
      <RelativeRow weights={ifReactNative([12], [6, 6])}>
        <CheckboxInput
          source="_isCheckboxChecked"
          value={isEnabled}
          label="Service Provider"
          onChangeCallback={() => setIsEnabled((prev) => !prev)}
        />
        {isEnabled && (
          <ClientAppToggleWrapper>
            <CheckboxInput
              source="isSharedInClientApp"
              label="Add to Client App"
            />
          </ClientAppToggleWrapper>
        )}
      </RelativeRow>
      {isEnabled && (<ServiceProvidersMultiDropdown {...props} />)}
    </IfFormData>
  );
}
